import { Card } from "@/components/ui/card";

export function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtMoney(amount, currency = "FCFA") {
  return `${(amount || 0).toLocaleString("fr-FR")} ${currency}`;
}

export function StatCard({ icon: Icon, label, value, accent }) {
  return (
    <Card className={"p-5 bg-af-card border-af rounded-md " + (accent ? "border-l-4 border-l-terracotta" : "")}>
      <div className="flex items-center gap-3 mb-2">
        <div className="h-9 w-9 rounded-md bg-[#F5EFD8] border border-af flex items-center justify-center">
          <Icon className="h-4 w-4 text-terracotta" />
        </div>
        <div className="text-xs uppercase tracking-widest text-af-muted font-semibold">{label}</div>
      </div>
      <div className="font-display font-extrabold text-3xl text-af">{value}</div>
    </Card>
  );
}
